module.exports = __webpack_public_path__ + "img/external.3d7fc887.png";